// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "console-app." + "3f1178c236d881a51c34" + ".js";
};